export default $ => {
  // Allow to filter the select containing the federations list in order that shows only the required federations
  const attr = 'accepted-federations-ids';
  const $input = $(`[data-${attr}]:not([data-${attr}=""])`);
  if ($input.length === 0) {
    return;
  }

  const $select = $('#membership_federation');
  const value = $select.val();

  let federationsIds = [];
  $input.each(function () {
    const ids = ($input.data(attr)+"").split(',');
    federationsIds = federationsIds.concat(ids);
  });

  $select.find('option').each(function() {
    const value = $(this).val();
    if (value !== '' && federationsIds.indexOf(value) === -1) {
      $(this).remove();
    }
  });

  $select.val(value > 0? value: '').trigger('change');
}



// WEBPACK FOOTER //
// ./assets/js/scripts/subscription-membership-form.js